export default {
  "p_comments:delete": "Пікірлер: Жою",
  "p_comments:edit": "Пікірлер: Өңдеу",
  "p_comments:create": "Пікірлер: Құру",
  "p_comments:view": "Пікірлер: Қарау",

  "p_price+proposals+++delete": "Баға ұсыныстары: Жою",
  "p_price+proposals+++edit": "Баға ұсыныстары: Өңдеу",
  "p_price+proposals+++create": "Баға ұсыныстары: Құру",
  "p_price+proposals+++view": "Баға ұсыныстары: Қарау",

  "p_change+protected+statuses": "Қорғалған статустарды өзгерту",

  "p__request+rate": "Баға сұранымдары",
  "p_delete+requests": "Сұранымдар: Жою",
  "p_editing+requests": "Сұранымдар: Өңдеу",
  "p_create+requests": "Сұранымдар: Құру",
  "p_view+requests": "Сұранымдар: Қарау",

  "p_edit+contact": "Байланыстар: Өңдеу",

  "p_change+credit+limit": "Кредиттік лимит: Өзгерту",

  "p_delete+clients": "Клиенттер: Жою",
  "p_editing+clients": "Клиенттер: Өңдеу",
  "p_create+clients": "Клиенттер: Құру",
  "p_view+clients": "Клиенттер: Қарау",

  "p_delete+carriers": "Тасымалдаушылар: Жою",
  "p_editing+carriers": "Тасымалдаушылар: Өңдеу",
  "p_create+carriers": "Тасымалдаушылар: Құру",
  "p_view+carriers": "Тасымалдаушылар: Қарау",

  "p_documents(transportation,+cmr,+photo):+view":
    "Құжаттар (тасымалдау, CMR, фото): Қарау",

  "p_other:+view": "Басқа: Қарау",
  "p_act:+view": "Акт: Қарау",

  "p_other:+create": "Басқа: Құру",
  "p_other:+delete": "Басқа: Жою",
  "p_other:+edit": "Басқа: Өңдеу",

  "p_acts:+create": "Акттар: Құру",
  "p_acts:+delete": "Акттар: Жою",
  "p_acts:+edit": "Акттар: Өңдеу",

  "p_edit+paid+invoices": "Төленген шоттар: Өңдеу",

  p_delete: "Жою",
  p_edit: "Өңдеу",
  p_create: "Құру",
  p_view: "Қарау",

  "p_edit+paid+invoices_2": "Төленген шоттар: Өңдеу",
  p_delete_2: "Жою",
  p_edit_2: "Өңдеу",
  p_create_2: "Құру",
  p_view_2: "Қарау",

  "p_edit+order+status+history": "Тапсырыс статус тарихы: Өңдеу",
  "p_view+order+status+history": "Тапсырыс статус тарихы: Қарау",

  "p_delete+financial": "Қаржы: Жою",
  "p_edit+financial": "Қаржы: Өңдеу",
  "p_view+financial": "Қаржы: Қарау",

  "p_edit+freight": "Фрахт: Өңдеу",
  "p_view+freight": "Фрахт: Қарау",

  p_margin: "Маржа",
  p_total: "Жалпы",

  "p_trips+in+order": "Тапсырыстағы рейстер",

  "p_documents(transportation,+cmr,+phtoto)":
    "Құжаттар (тасымалдау, CMR, фото)",

  "p_cargo+information": "Жүк туралы ақпарат",
  "p_client+information": "Клиент туралы ақпарат",

  p_profit: "Пайда",

  "p_delete+orders": "Тапсырыстар: Жою",
  "p_edit+status": "Статус: Өңдеу",
  "p_editing+orders": "Тапсырыстар: Өңдеу",
  "p_create+orders": "Тапсырыстар: Құру",
  "p_view+orders": "Тапсырыстар: Қарау",

  "p_delete+trips": "Рейстер: Жою",
  "p_update+trips": "Рейстер: Жаңарту",
  "p_create+trips": "Рейстер: Құру",
  "p_trips+view": "Рейстер: Қарау",

  "p_your+own+departments+orders": "Өз бөлімінің тапсырыстары",
  "p_your+own+orders": "Өз тапсырыстары",
  "p_all+orders": "Барлық тапсырыстар",

  "p_your+own+departments+requests": "Өз бөлімінің сұранымдары",
  "p_your+own+requests": "Өз сұранымдары",
  "p_all+requests": "Барлық сұранымдар",

  "p_your+own+departments+clients": "Өз бөлімінің клиенттері",
  "p_your+own+clients": "Өз клиенттері",
  "p_all+clients": "Барлық клиенттер",

  "p_your+own+departments+carriers": "Өз бөлімінің тасымалдаушылары",
  "p_your+own+carriers": "Өз тасымалдаушылары",
  "p_all+carriers": "Барлық тасымалдаушылар",

  "p_your+own+departments+trips": "Өз бөлімінің рейстері",
  "p_your+own+trips": "Өз рейстері",
  "p_all+trips": "Барлық рейстер",

  l_Username: "Пайдаланушы аты",
  l_User_password: "Құпия сөз",
  l_Forgot_password: "Құпия сөзді қалпына келтіру",
  l_Login: "Кіру",
  l_Sign_out: "Шығу",
  l_EmailorPasswordisWrong: "Электрондық пошта немесе құпия сөз дұрыс емес",
  l_Requests: "Сұраулар",
  l_Orders: "Тапсырыстар",
  l_Order_code_referral: "Рефералдық код",
  l_Order_code_referral_short: "Реф. код",
  l_Finance: "Қаржы",
  l_Clients: "Клиенттер",
  l_Carriers: "Тасымалдаушылар",
  l_Settings: "Параметрлер",
  l_Organization: "Ұйым",
  l_Templates: "Үлгілер",
  l_Classifiers: "Анықтамалықтар",
  l_System: "Жүйе",
  l_Log: "Лог",
  l_Companies: "Компаниялар",
  l_Departments: "Бөлімдер",
  l_Employees: "Қызметкерлер",
  l_Groups_of_employees: "Қызметкерлер топтары",
  l_Company_name: "Компанияның атауы",
  l_Name_in_original: "Түпнұсқадағы аты",
  l_Company_code: "Компания коды",
  l_VAT_code: "ҚҚС коды",
  l_Business_number: "Типтің номеры",
  l_Address: "Мекенжай",
  l_Address_for_correspondence: "Хат-хабар мекенжайы",
  l_Banks: "Банктер",
  l_Cargo_statuses: "Жүк статустары",
  l_Client_types: "Клиент түрлері",
  l_Document_statuses: "Құжат статустары",
  l_Order_statuses: "Тапсырыс статустары",
  l_Railway_stations: "Темір жол станциялары",
  l_Transport_types: "Транспорт түрлері",
  l_Trip_statuses: "Рейс статустары",
  l_VAT_rates: "ҚҚС тарифтері",
  l_Workers_posts: "Қызметкерлердің лауазымдары",
  l_Whatsapp_notification_send: "WhatsApp арқылы хабарландыру жіберу",
  l_Name: "Аты",
  l_Unofficial_name: "Бейресми аты",
  l_Provide_access_to_carrier: "Тасымалдаушыға көріну",
  l_Branch: "Филиал",
  l_Code__: "МФО (БИК, BLZ)",
  l_Post_code: "Пошта коды",
  l_Action: "Әрекет",
  l_Add: "Қосу",
  l_Update: "Жаңарту",
  l_Edit: "Өңдеу",
  l_Submit: "Жіберу",
  l_Cancel: "Болдырмау",
  l_Are_you_sure_delete_this_task: "Бұл тапсырманы жойғыңыз келе ме?",
  l_Yes: "Иә",
  l_No: "Жоқ",
  l_Keyword: "Кілттік сөз",
  l_Search: "Іздеу",
  l_Active: "Активті",
  l_Initial: "Бастапқы",
  l_Final: "Соңғы",
  l_Legal_name: "Заңды атауы",
  l_NotFound: "Табылмады",
  l_Succeed: "Операция сәтті өтті",
  l_Segment_name: "Сегмент атауы",
  l_Segment_priority: "Сегмент приоритеті",
  l_Color: "Түс",
  l_By_default: "Әдепкі",
  l_Yellow: "Сары",
  l_Green: "Жасыл",
  l_Grey: "Сұр",
  l_Red: "Қызыл",
  l_Orange: "Қызғылт-сары",
  l_Status_name: "Статус атауы",
  l_Priority: "Приоритеті",
  l_Status_type: "Статус түрі",
  l_Text_colour: "Мәтін түсі",
  l_Background_colour: "Фон түсі",
  l_After_setting_status: "Статус орнатылғаннан кейін",
  l_Message_for_seller: "Сатушыға арналған хабарлама",
  l_Topic_of_the_message_for_seller_TWIG:
    "TWIG сатушысына арналған хабарлама тақырыбы",
  l_Name_2: "Атауы",
  l_Railway_station: "Темір жол станциясы",
  l_Code: "Код",
  l_Railway: "Темір жол",
  l_Railway2: "Темір жол транспорты",
  l_Rate: "Тариф",
  l_VAT_law: "ҚҚС туралы заң",
  l_third_party_code: "Бөгде код",
  l___CountVat: "ҚҚС тарифі есепке алынбайды",
  l_Default_VAT_rate: "Әдепкі ҚҚС мөлшерлемесі",
  l_Error: "Қате",
  l_Basic_information: "Негізгі ақпарат",
  l_Signatures: "Қолтаңбалар",
  l_Directors_full_name: "Директордың аты-жөні",
  l_In_the_name_of_whom: "Кімнің атынан",
  l_Post: "Лауазым",
  l_VAT_rate: "ҚҚС мөлшерлемесі",
  l_RRC: "КПП",
  l_OGRN: "ОГРН",
  l_Pricing_type: "Бағаны есептеу түрі",
  l_Contact_information: "Заңды мекенжайы",
  l_Country: "Мемлекет",
  l_City: "Қала",
  l_Correspondent_information: "Корреспонденттік ақпарат",
  l_Telephone: "Телефон",
  l_Fax: "Факс",
  l_Email: "Эл.пошта",
  l_Website: "Веб-сайт",
  l_Main_company: "Негізгі компания",
  l_Operating_account: "Есеп айырысу шоты",
  l_Bank_code: "Банк коды",
  l_Bank: "Банк",
  l_Different_invoices_for_different_currencies:
    "Түрлі валюталар үшін түрлі шот-фактуралар",
  l_Currency: "Валюта",
  l_Correspondent_bank: "Корреспонденттік банк",
  l_Print: "Басып шығару",
  l_Company_logotype: "Компания логотипі",
  l_Signature: "Қолтаңба",
  l_correspondent_account: "Корреспонденттік шот",
  l_Inc_VAT_price: "ҚҚС қосылған баға",
  l_Ex_VAT_price: "ҚҚС қосылмаған баға",
  l_Bank_name: "Банк атауы",
  l_Click_or_drag_ile_to_this_area_to_upload:
    "Файлды жүктеп салу үшін осы аймаққа басыңыз немесе файлды әкеліп қойыңыз",
  l_Department_name: "Бөлім атауы",
  l_Department_prefix: "Бөлім префиксі",
  l_Company: "Компания",
  l_Login_email: "Кіру электрондық поштасы",
  l_Groups: "Топтар",
  l_Name_Surname: "Аты, тегі",
  l_Surname: "Тегі",
  l_Date_of_last_visit: "Соңғы келген күні",
  l_Mail_settings: "Пошта параметрлері",
  l_Password: "Құпия сөз",
  l_Reset_your_password:
    "Құпия сөзді қалпына келтіргіңіз келетініне сенімдісіз бе?",
  l_For_bonus: "бонус үшін %, %",
  l_Employee_prefix: "Қызметкер префиксі",
  l_Department: "Бөлім",
  l_Access_rights: "Құқықтары",
  l_All: "Барлығы",
  l_YourOwnDepartment: "Өз бөлімшесі",
  l_YourOwn: "Тек өзі",
  l_Unlimited_access: "Шексіз құқықтар",
  l_Additional_information: "Қосымша ақпарат",
  l_Main: "Негізгі",
  l_Access: "Доступ",
  l_Special_rights: "Арнайы құқықтар",
  l_Group: "Топ",
  l_Numeration: "Нумерация",
  l_Numeration_name: "Нөмірлеу атауы",
  l_Numeration_for: "Нөмірлеу",
  l_Employee: "Қызметкер",
  l_Prefix: "Префикс",
  l_Year: "Жыл",
  l_Month: "Ай",
  l_Delimiter: "Бөлгіш",
  l_Number_of_digits: "Цифрлар саны",
  l_Index: "Индекс",
  l_Suffix: "Суффикс",
  l_View: "Көру",
  l_Client: "Клиент",
  l_Consolidation: "Консолидация",
  l_Cargos: "Жүктер",
  l_Trips: "Рейстер",
  l_Cargos_status: "Жүктер статусы",
  l_Salary_calculation: "Жалақыны есептеу",
  l_Show_filters: "Фильтрді көрсету",
  l_Order_date: "Тапсырыс күні",
  l_Date: "Күн",
  l_Users: "Пайдаланушылар",
  l_Documents: "Құжаттар",
  l_Transport: "Транспорт",
  l_Other: "Басқа",
  l_Sort: "Сұрыптау",
  l_Order_number: "Тапсырыс нөмірі",
  l_Order_status: "Тапсырыс статусы",
  l_Loading_area: "Жүктеу аймағы",
  l_Unloading_area: "Жүк түсіру аймағы",
  l_Loading_date: "Жүктеу күні",
  l_Days_of_trip: "Жолдағы күндер",
  l_Car_number: "Көлік нөмірі",
  l_Freight: "Фрахт",
  l_Costs: "Шығындар",
  l_Profit: "Пайда",
  l_User: "Пайдаланушы",
  l_Trip_number: "Рейс нөмірі",
  l_Weight: "Салмағы",
  l_Volume: "Көлемі",
  l_Total_freight: "Жалпы фрахт",
  l_Change_status: "Статусты өзгерту",
  l_XML_unloading: "XML жүктеп алу",
  l_Managers: "Менеджерлер",
  l_Date_of_creation: "Жасалу күні",
  l_Client_type: "Клиент түрі",
  l_TIN_taxpayer_ID_number_VAT: "УНН/ЕГРПОУ/VAT№",
  l_Activity_area: "Қызмет түрі",
  l_OKPO: "ОКПО",
  l_TIN: "ЖСН",
  l_BIN: "БСН",
  l_TRN: "РНН",
  l_Legal_address: "Заңды мекенжайы",
  l_Postal_address: "Пошта мекенжайы",
  l_Payment_rules: "Төлем ережелері",
  l_Credit_limit: "Несие лимиті",
  l_Payment_delay: "Төлемді кейінге қалдыру",
  l_Limit_exceeded: "Лимиттен асу",
  l_Deferred_payment_terms: "Төлемді кейінге қалдыру шарттары",
  l_Email_to_send_documents: "Құжаттарды жіберуге арналған электрондық пошта",
  l_Send_debt_remindings: "Қарыздар туралы ескерту жіберу",
  l_Swift: "Swift",
  l_PleaseEnterName: "Аты-жөніңізді енгізіңіз",
  l_Contact_persons_posts: "Байланыстағы тұлғаның лауазымы",
  l_Contact_person: "Байланыстағы тұлға",
  l_Manager: "Менеджер",
  l_Days_from_the_latest_contract: "Соңғы келісім-шарттан кейінгі күндер",
  l_Order_quantity: "Тапсырыс саны",
  l_Purchase_funnel: "Сату воронкасы",
  l_Purchase_funnel_status: "Сату воронкасының статусы",
  l_Phone: "Телефон",
  l_Creation_date: "Жасалу күні",
  l_Type_of_the_received_document: "Алынған құжат түрі",
  l_Contact_personnel: "Байланыс персоналы",
  l_Company_details: "Компания реквизиттері",
  l_Active_requests: "Активті сұраулар",
  l_Archive_requests: "Мұрағат сұраулар",
  l_Archive: "Мұрағаттау",
  l_Duly_represtnted: "Өкілеттігі",
  l_Use_in_all_documents: "Барлық құжаттарда пайдалану",
  l_Phone_number: "Телефон нөмірі",
  l_Skype: "Skype",
  l_ICQ: "ICQ",
  l_Comments: "Пікірлер",
  l_PasswordNotLessThan6Letters: "Құпия сөзде кемінде 6 таңба болуы керек",
  l_Existed: "Бұрыннан бар",
  l_EmailExisted: "Мұндай электрондық пошта бұрыннан бар",
  l_Clients_order_number: "Клиенттің тапсырыс нөмірі",
  l_Contacts: "Контактілер",
  l_Default_forwarder: "Координатор",
  l_Additional_managers: "Freight coordinator",
  l_Price: "Баға",
  l_Price_with_VAT: "ҚҚС қосылған баға",
  l_Deferred_payment_days: "Төлемді кейінге қалдыру (күндер)",
  l_Deferred_payment_conditions: "Төлемді кейінге қалдыру жағдайы",
  l_Full_text: "Толық мәтін",
  l_One_or_more_content_missing:
    "Контенттің бір немесе бірнеше элементтері жоқ",
  l_Statuses: "Статустар",
  l_Invoices: "Шот-фактуралар",
  l_Tasks: "Тапсырмалар",
  l_Number: "Нөмер",
  l_Initial_freight: "Бастапқы баға",
  l_Expenses: "Шығындар",
  l_Forwarders: "Операторлар",
  l_Documents_with_clients: "Клиенттермен құжаттар",
  l_Cargo_number: "Жүк нөмірі",
  l_Cargo_name: "Жүк атауы",
  l_Cargo_parameters: "Жүк параметрлері",
  l_Loading: "Жүктеу",
  l_Reloading_storage_place: "Қайта жүктеу/сақтау орны",
  l_Date_of_transhipment: "Қайта жүктеу күні",
  l_Unloading: "Жүк түсіру",
  l_Consignment_Price: "Жүк бағасы",
  l_Loading_place: "Жүктеу орны",
  l_Time: "Уақыт",
  l_Place_Company: "Орын / Компания",
  l_Rate_date: "Курс күні",
  l_Contact_person_and_telephone: "Байланыстағы тұлға және телефон",
  l_Loading_place_customs: "Жүктеу кедені",
  l_To: "Дейін",
  l_Unloading_place: "Жүк түсіру орны",
  l_Unloading_place_customs: "Жүк түсіру кедені",
  l_Packing_type_quantity: "Қаптама түрі/саны",
  l_Pallets: "Паллеттер",
  l_LDM: "LDM",
  l_Length: "Ұзындығы",
  l_Width: "Ені",
  l_Height: "Биіктігі",
  l_Partial_cargo: "Жартылай жүк",
  l_Cargo_additional_information: "Жүк туралы қосымша ақпарат",
  l_Attributes: "Атрибуттар",
  l_Insurance: "Сақтандыру",
  l_Terms_of_delivery: "Жеткізу шарттары (Инкотермс 2010 бойынша)",
  l_Transit_Time: "Транзит уақыты",
  l_Status: "Статус",
  l_Unloading_date: "Жүк түсіру күні",
  l_Carrier: "Тасымалдаушы",
  l_Forwarder: "Оператор",
  l_Received_invoices: "Алынған шот-фактуралар",
  l_Cargos_and_Routes: "Жүктер мен Маршруттар",
  l_Carrier_company: "Тасымалдаушы компания",
  l_Carrier_contract_number_with_carrier:
    "Тасымалдаушымен жасалған шарттың нөмірі",
  l_Insurance_policy_valid_until: "Сақтандыру полисінің жарамдылық мерзімі",
  l_Number_in_carriers_system: "Тасымал жүйесіндегі нөмір",
  l_Trip: "Рейс",
  l_Terms_and_conditions_of_payment: "Төлем мерзімі мен шарттары",
  l_Vehicle_number: "Көлік нөмірі",
  l_Trailers_numbers: "Прицеп нөмірі",
  l_Transport_type: "Транспорт түрі",
  l_Loading_method: "Жүктеу әдісі",
  l_Passport_number: "Паспорт нөмірі",
  l_Driver: "Жүргізуші",
  l_Container_number: "Контейнер нөмірі",
  l_Sizes_L_W_H: "Өлшемдері (Ұ*Е*Б)",
  l_Amount: "Саны",
  l_Packing: "Қаптама",
  l_Order: "Тапсырыс",
  l_Route: "Маршрут",
  l_Cargo_status: "Жүк статусы",
  l_Received_invoice: "Алынған шот-фактура",
  l_Expense: "Шығын",
  l_Expenses_incl_VAT: "ҚҚС қосылған шығындар",
  l_Dont_count_in_balance: "Шығын қаржыда есептелмесін",
  l_Separate_line_in_the_invoice: "Шот-фактурадағы жеке жол",
  l_Expense_description: "Шығындардың сипаттамасы",
  l_Document_name: "Құжат атауы",
  l_Document_expiration_date: "Құжаттың жарамдылық мерзімі",
  l_Available_for_client: "Клиент үшін қол жетімді",
  l_Type: "Түр",
  l_Template: "Құжат үлгісі",
  l_Attached_file: "Тіркелген файл",
  l_Document_number: "Құжат нөмірі",
  l_Document_date: "Құжат күні",
  l_Provide_access_to_the_client: "Клиентке құқық беру",
  l_File: "Файл",
  l_OverheadDocuments: "Үстеме құжаттар",
  l_Tags: "Тегтер",
  l_Rail_trips: "Темір жол рейстері",
  l_OtherDocuments: "Басқа құжаттар",
  l_Acts: "Актілер",
  l_Photos: "Суреттер",
  l_Link: "Сілтеме",
  l_To_comment: "Пікір қалдыру үшін",
  l_Comment: "Пікір",
  l_Cargo: "Жүк",
  l_Place: "Орын",
  l_ETA: "ETA",
  l_Sent: "Жіберілді",
  l_Author: "Автор",
  l_Trip_type: "Рейс түрі",
  l_Neutral: "Бейтарап",
  l_Finish: "Соңғы",
  l_Change_the_status_of_cargo_on_this_flight:
    "Осы рейстегі жүктердің статусын өзгерту",
  l_Are_you_sure_you_want_to_update: "Жаңартқыңыз келетініне сенімдісіз бе?",
  l_Finance_template: "Қаржы үлгісі",
  l_Wagon_data: "Вагон деректері",
  l_Train_Trip_number: "Поезд/рейс нөмірі",
  l_Car_Container_number: "Вагон/контейнер нөмірі",
  l_Cargo_data: "Жүк деректері",
  l_GNG_code: "ГНГ код",
  l_Classes_of_transport_rates: "ЕТСНГ",
  l_Rules_for_using_the_car: "Автокөлікті пайдалану ережелері",
  l_Wagon_renter: "Вагонды жалға алушы",
  l_Freight_with_VAT: "ҚҚС қосылған фрахт",
  l_Login_: "Кіру",
  l_Close: "Жабу",
  l_Directions: "Бағыттар",
  l_From: "Бастап",
  l_Countries: "Мемлекеттер",
  l_Drivers_name: "Жүргізушінің аты",
  l_Drivers_surname: "Жүргізушінің тегі",
  l_Middle_name: "Жүргізушінің әкесінің аты",
  l_Passport: "Паспорт",
  l_Driving_licence_number: "Жүргізуші куәлігінің нөмірі мен сериясы",
  l_Driving_licence_categories: "Жүргізуші куәлігінің санаттары",
  l_Fuel_card: "Жанармай картасы",
  l_Is_active: "Белсенді",
  l_Bank_account: "Банк шоты",
  l_Contact_type: "Байланыс түрі",
  l_Vehicle: "Көлік",
  l_Specifications: "Техникалық сипаттамалар",
  l_updateStatus: "Статус жаңарту",
  l_Date_of_employment: "Жұмысқа қабылдау күні",
  l_Euro_emission_class: "Экологиялық сынып",
  l_Trailer_number: "Прицеп нөмірі",
  l_Brand: "Марка",
  l_Model: "Модель",
  l_Production_date: "Өндірілген күні",
  l_Body_number: "Кузов нөмірі",
  l_Registration_date: "Тіркеу күні",
  l_Tech_passport_validity: "Техникалық паспорттың жарамдылық мерзімі",
  l_License_number: "Лицензия нөмірі",
  l_License_validity_date: "Лицензияның жарамдылық мерзімі",
  l_Drivers: "Жүргізушілер",
  l_Transport_information: "Транспорт деректері",
  l_Vehicle_empty_weight: "Көліктің таза салмағы",
  l_Vehicle_full_weight: "Көліктің толық салмағы",
  l_Vehicle_axels: "Көлік осьтері",
  l_Max_weight: "Максималды жүктеу салмағы",
  l_Max_euro_pallets: "Максималды еуро паллеттер саны",
  l_Relevant_documents: "Тиісті құжаттар",
  l_Document_groups: "Құжаттар топтары",
  l_Template_name: "Үлгі атауы",
  l_Is_default: "Әдепкі ме",
  l_Service_type: "Қызмет түрі",
  l_Statistical: "Статистикалық",
  l_Statistic: "Статистика",
  l_Unregistered: "Тіркелмеген",
  l_Role: "Рөл",
  l_Permission: "Рұқсат",
  l_Description: "Сипаттама",
  l_Peromission_key: "Рұқсат кілті",
  l_Parent_option: "Тектік параметр",
  l_Level: "Деңгей",
  l_Border_point: "Шекара нүктесі",
  l_Cost_per_cargo: "Жеке жүктің құны",
  l_By_weight: "Салмағы бойынша",
  l_By_volume: "Көлемі бойынша",
  l_By_weight_and_volume: "Салмағы және көлемі бойынша",
  l_Batch_setting_cargo_status: "Жүк статусын пакеттік орнату",
  l_Selected: "Таңдалған",
  l_not_selected: "Таңдалмаған",
  l_Distribute_percent: "Үлестіру пайызы",
  l_Distribute_price: "Үлестіру бағасы",
  l_Total: "Барлығы",
  l_Clear: "Тазалау",
  l_By: "Бойынша",
  l_Add_date: "Күнді қосу",
  l_Update_date: "Жаңарту күні",
  l_Descending: "Кемуі бойынша",
  l_Ascending: "Өсуі бойынша",
  l_Invoice: "Шот-фактура",
  l_Invoices_issued: "Шығарылған шот-фактуралар",
  l_invoiceNumber: "Шот-фактура нөмірі",
  l_senderInvoice: "Компания",
  l_issuedDate: "Шот-фактура шығарылды",
  l_receivingDate: "Алынған күні",
  l_payUntilDate: "Төлеудің соңғы күні",
  l_Trip_status: "Рейс статусы",
  l_Without_VAT: "ҚҚС қосылмаған",
  l_With_VAT: "ҚҚС қосылған",
  l_Invoice_line: "Шот-фактура жолы",
  l_Unit: "Бірлік",
  l_Received_from: "Беруші",
  l_Company_which_received_the_invoice: "Шот-фактураны алған компания",
  l_Breaking_rule: "Сұрыптау ережесі",
  l_Contractor: "Орындаушы",
  l_Payer: "Төлеуші",
  l_Language: "Тіл",
  l_Made: "Жасаған",
  l_Notes: "Ескертпелер",
  l_Devider: "Бөлгіш",
  l_Element: "Элемент",
  l_Percent: "Пайыз",
  l_INN_EGRPOU_VAT_BIN_UNN: "ИНН, ЕГРПОУ, VAT, БИН, УНН",
  l_Start: "Бастау",
  l_End: "Соңы",
  l_Contract_date: "Келісімшарт күні",
  l_Contract_number: "Келісімшарт нөмірі",
  l_Has_contract: "Келісімшарт бар",
  l_Contragents: "Контрагенттер",
  l_Issued_invoice_in_order: "Тапсырыс берілген шот-фактура",
  l_Status_history: "Статустар тарихы",
  l_New_request: "Жаңа клиент қосу",
  l_Notification_language: "Хабарлама жіберу тілі",
  l_Classifier_section: "Нұсқаулық бөлімі",
  l_Client_type_definition:
    "Клиент түрлері - маңыздылығы/шұғылдығы бойынша Клиенттердің жіктелуі Клиент картасында толтырылады және Сұраныстармен әрекеттеседі. Каталогты толтыру кезінде сегменттің басымдылығын орнатуға болады. Бұл сан осы түрі бар клиенттен сұраудың маңыздылығы мен орнын анықтайды. Ол келесідей жұмыс істейді: каталогқа VIP клиент түрін қосыңыз, сегмент басымдығы 1. Әрі қарай, қалаған Клиенттің картасында осы түрді таңдаңыз және осы Клиенттің барлық сұраулары жалпы Сұраныс кестесінің ең жоғарғы жағында орналасады, қабылдау тәртібіне қарамастан. Сондай-ақ, белгілі бір түрдегі Клиенттер бойынша таңдау жасау үшін Клиенттер блогында сүзгіні пайдалануға болады.",
  l_Company_is_required: "Компанияны таңдаңыз",
  l_File_is_required: "Файлдарды жүктеңіз",
  l_Comment_is_required: "Пікіріңізді енгізіңіз",
  l_Company_name_is_required: "Компания атауын енгізіңіз",
  l_Business_number_is_required: "Нөмірді енгізіңіз",
  l_Required_field: "Міндетті өріс",
  l_Select_required: "Таңдаңыз",
};
